<div class="modal-header">
	<div class="modal-title text-center w-100 fw-bold">
		Conflit d'affectation détecté
	</div>
	<button
		type="button"
		class="btn-close close pull-right"
		aria-label="Close"
		(click)="bsModalResolveConflict.hide()"
	></button>
</div>
<div class="modal-body">
	<div class="row d-flex justify-content-center align-items-center">
		Un problème a été détecté pour ce créneau.
	</div>
	<div class="row d-flex justify-content-center align-items-center mb-3">
		Que souhaitez-vous faire ?
	</div>
	<div class="row">
		<table class="table text-center">
			<caption>
				Conflit d'affectation
			</caption>
			<thead>
				<tr>
					<th scope="col"></th>
					<th scope="col">{{ labelInterventionCapitalized }} #1</th>
					<th scope="col">en conflit avec</th>
					<th scope="col">{{ labelInterventionCapitalized }} #2</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<th scope="row">Date</th>
					<td>
						{{ mission?.missionRequest.date | date : 'dd/MM/YYYY' }}
					</td>
					<td></td>
					<td>
						{{
							overlappingResponse?.missionInConflict.missionRequest.date
								| date : 'dd/MM/YYYY'
						}}
					</td>
				</tr>
				<tr>
					<th scope="row">Lieu</th>
					<td>
						{{
							mission?.missionRequest.missionPlace
								? mission?.missionRequest.missionPlace.nameDisplay
								: mission?.missionRequest.beneficiaire?.address?.label
						}}
					</td>
					<td></td>
					<td>
						{{
							overlappingResponse?.missionInConflict.missionRequest.missionPlace
								? overlappingResponse?.missionInConflict.missionRequest
										.missionPlace.nameDisplay
								: overlappingResponse?.missionInConflict.missionRequest
										.beneficiaire?.address?.label
						}}
					</td>
				</tr>
				<tr>
					<th scope="row">Début prévu à</th>
					<td>
						{{ dateUtils.timeConvert(mission?.realStart) }}
					</td>
					<td></td>
					<td>
						{{
							dateUtils.timeConvert(
								overlappingResponse?.missionInConflict?.realStart
							)
						}}
					</td>
				</tr>
				<tr>
					<th scope="row">Fin prévu à</th>
					<td>
						{{ dateUtils.timeConvert(mission?.realEnd) }}
					</td>
					<td></td>
					<td>
						{{
							dateUtils.timeConvert(
								overlappingResponse?.missionInConflict?.realEnd
							)
						}}
					</td>
				</tr>
				<tr>
					<th scope="row">{{ labelBeneficiaireCapitalized }}</th>
					<td>
						{{ mission?.missionRequest.beneficiaire?.firstName }}
						{{ mission?.missionRequest.beneficiaire?.lastName }}
					</td>
					<td></td>
					<td>
						{{
							overlappingResponse?.missionInConflict.missionRequest.beneficiaire
								?.firstName
						}}
						{{
							overlappingResponse?.missionInConflict.missionRequest.beneficiaire
								?.lastName
						}}
					</td>
				</tr>
				<tr>
					<th scope="row">Compétence</th>
					<td>
						<ul>
							<li *ngFor="let careSkill of mission?.missionRequest.careSkills">
								{{ careSkill.name }}
							</li>
						</ul>
					</td>
					<td></td>
					<td>
						<ul>
							<li
								*ngFor="
									let careSkill of overlappingResponse?.missionInConflict
										.missionRequest.careSkills
								"
							>
								{{ careSkill.name }}
							</li>
						</ul>
					</td>
				</tr>
				<tr>
					<th scope="row">{{ labelIntervenantCapitalized }}</th>
					<td>
						{{ this.initialEmployee?.firstName }}
						{{ this.initialEmployee?.lastName }}
					</td>
					<td></td>
					<td>
						{{ this.employee?.firstName }}
						{{ this.employee?.lastName }}
					</td>
				</tr>
			</tbody>
		</table>
	</div>
	<div class="col">
		<div class="row">
			<button
				*ngIf="!isMobile && overlappingResponse?.swapPossible"
				type="button"
				[disabled]="isAssignationInProgress"
				class="btn theme-main-color-button mb-3"
				(click)="confirmSwap()"
			>
				Échanger les intervenants
			</button>
		</div>
		<div class="row">
			<button
				*ngIf="
					!isMobile &&
					overlappingResponse?.forcedAssignationPossible &&
					this.employee !== null
				"
				type="button"
				[disabled]="isAssignationInProgress"
				class="btn theme-main-color-button mb-3"
				(click)="forceAssignation(this.employee?.id)"
			>
				Affecter
				<strong>{{
					this.employee?.firstName + ' ' + this.employee?.lastName
				}}</strong>
				aux deux {{ labelInterventionPluralized }}
			</button>
		</div>
		<div class="row">
			<button
				*ngIf="!isMobile && overlappingResponse?.normalAssignation"
				type="button"
				[disabled]="isAssignationInProgress"
				class="btn theme-main-color-button mb-3"
				(click)="reassignation()"
			>
				Affecter
				<strong>{{
					this.initialEmployee !== null
						? this.initialEmployee?.firstName +
						  ' ' +
						  this.initialEmployee?.lastName
						: this.employee?.firstName + ' ' + this.employee?.lastName
				}}</strong>
				à
				<strong
					>{{ labelInterventionCapitalized }}
					{{ this.initialEmployee ? '#2' : '#1' }}</strong
				>
			</button>
		</div>
	</div>
</div>
<div class="modal-footer">
	<button
		type="button"
		class="btn theme-main-color-button me-2"
		(click)="bsModalResolveConflict.hide()"
	>
		Retour
	</button>
</div>
